import React from 'react';
import { Link } from 'react-router-dom';
import clsx from 'clsx';

const StatCard = ({ title, value, icon, color, trend, trendText, link }) => {
  const colorClasses = {
    primary: 'bg-primary text-white',
    success: 'bg-success text-white',
    warning: 'bg-warning text-white',
    danger: 'bg-danger text-white',
    info: 'bg-info text-white'
  };

  const trendClasses = {
    danger: 'text-red-600',
    success: 'text-green-600',
    neutral: 'text-gray-600'
  };

  const trendIcons = {
    danger: 'fa-arrow-up',
    success: 'fa-arrow-down',
    neutral: 'fa-minus'
  };

  return (
    <div className="bg-white overflow-hidden shadow rounded-lg card-hover">
      <div className="p-5">
        <div className="flex items-center">
          <div className={clsx('flex-shrink-0 rounded-md p-3', colorClasses[color])}>
            <i className={`fa ${icon}`}></i>
          </div>
          <div className="ml-5 w-0 flex-1">
            <dl>
              <dt className="text-sm font-medium text-gray-500 truncate">{title}</dt>
              <dd className="flex items-baseline">
                <div className="text-2xl font-semibold text-gray-900">{value}</div>
                {trend && trendText && (
                  <div className={clsx('ml-2 flex items-baseline text-sm font-semibold', trendClasses[trend])}>
                    <i className={`fa ${trendIcons[trend]} mr-1`}></i>
                    <span>{trendText}</span>
                  </div>
                )}
              </dd>
            </dl>
          </div>
        </div>
      </div>
      {link && (
        <div className="bg-gray-50 px-5 py-3">
          <div className="text-sm">
            <Link
              to={link}
              className="font-medium text-primary hover:text-blue-700"
            >
              查看详情
            </Link>
          </div>
        </div>
      )}
    </div>
  );
};

export default StatCard;